import React from "react";
import Spinner from "react-webpack-spinner";
import { Field, reduxForm } from "redux-form";

import FormField from "./FormField";

class UserEditForm extends React.Component {
  componentWillMount() {
    this.props.onLoadUser();
  }

  render() {
    const {
      savingUser,
      savedUser,
      saveUserFailed,
      isLoadingUser,
      user,
      saveUserErrors,
      onEditInstitution
    } = this.props;

    if (isLoadingUser) {
      return (
        <div className="flex-1-1 has-text-centered">
          <Spinner width={32} height={32} color="#000" />
        </div>
      );
    }

    return (
      <div className="content">
        {savingUser ? (
          <div>
            <h1 className="title">
              {user._key ? "Ihre Daten bearbeiten" : "Registrierung"}
            </h1>
            <Spinner width={32} height={32} color="black" /> Einen Augenblick…
          </div>
        ) : (
          <div>
            <form onSubmit={this.props.handleSubmit}>
              <Field name="key" component="input" type="hidden" />
              <h1 className="title">
                {user._key ? "Ihre Daten bearbeiten" : "Registrierung"}
              </h1>
              {!user._key && (
                <p className="info">
                  Wenn Sie eine Einrichtung leiten oder für eine Einrichtung
                  verantwortlich sind, die im Atlas noch nicht vorhanden ist,
                  können Sie nach der Registrierung eine neue Einrichtung
                  anlegen.
                </p>
              )}
              {saveUserFailed && (
                <div className="notification is-danger">
                  Fehler beim Speichern
                </div>
              )}

              {savedUser && (
                <div className="notification is-success">
                  Erfolgreich gespeichert
                </div>
              )}

              {(!!user.is_admin || !!(user.is_district_admin || []).length) && (
                <div className="notification is-info">
                  {!!user.is_admin && (
                    <span>Sie sind als Administrator angemeldet.</span>
                  )}
                  {!!(user.is_district_admin || []) && (
                    <span>
                      Sie sind als Bezirks-Admin angemeldet für die Bezirk(e):{" "}
                      {user.is_district_admin.join(", ")}
                    </span>
                  )}
                </div>
              )}

              <FormField
                label="Nachname"
                name="last_name"
                component="input"
                type="text"
                error={saveUserErrors.last_name}
              />

              <FormField
                label="Vorname"
                name="first_name"
                component="input"
                type="text"
                error={saveUserErrors.first_name}
              />

              {!user._key ? (
                <FormField
                  label="E-Mail"
                  name="email"
                  component="input"
                  type="email"
                  error={saveUserErrors.email}
                />
              ) : (
                <div className="control">
                  <label className="label">E-Mail</label>
                  {user.email}
                </div>
              )}

              <FormField
                label="Passwort"
                name="password1"
                component="input"
                type="password"
                error={saveUserErrors.password1}
              />

              <FormField
                label="Passwort wiederholen"
                name="password2"
                component="input"
                type="password"
                error={saveUserErrors.password2}
              />

              <button className="button is-success">
                {user._key ? "Speichern" : "Registrieren"}
              </button>
            </form>
            {!!(user.institutions || []).length && (
              <div style={{ marginTop: 30 }}>
                <h3>Ihre Einrichtungen</h3>
                <ul>
                  {user.institutions.map(i => {
                    return (
                      <li key={i._key}>
                        <a href="#" onClick={() => onEditInstitution(i._key)}>
                          {i.name}
                        </a>
                      </li>
                    );
                  })}
                </ul>
              </div>
            )}
          </div>
        )}
      </div>
    );
  }
}

export default reduxForm({
  form: "user"
})(UserEditForm);



/** WEBPACK FOOTER **
 ** ./src/components/UserEditForm.jsx
 **/